import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { REQUIRE_VISITOR_LOGIN } from '../config/auth';
import { clearVisitorSession, getVisitorInfo, isVisitorLoggedIn } from '../utils/session';
import './Navbar.css';

const Dropdown = ({ label, items, align = 'left' }) => {
  const [open, setOpen] = useState(false);
  const [timeoutId, setTimeoutId] = useState(null);

  const handleMouseEnter = () => {
    if (timeoutId) {
      clearTimeout(timeoutId);
      setTimeoutId(null);
    }
    setOpen(true);
  };

  const handleMouseLeave = () => {
    const id = setTimeout(() => {
      setOpen(false);
    }, 800);
    setTimeoutId(id);
  };

  React.useEffect(() => {
    return () => {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
    };
  }, [timeoutId]);

  return (
    <div
      className={`nav-item has-dropdown ${open ? 'open' : ''}`}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <button className="nav-link" type="button" aria-haspopup="true" aria-expanded={open}>
        {label}
      </button>
      <div
        className={`dropdown-menu ${align === 'right' ? 'align-right' : ''}`}
        role="menu"
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        {items.map((item, idx) => (
          <a key={idx} className="dropdown-item" href={item.href || '#'} onClick={item.onClick}>
            {item.label}
          </a>
        ))}
      </div>
    </div>
  );
};

const Navbar = () => {
  const navigate = useNavigate();

  const visitor = getVisitorInfo();
  const loggedIn = isVisitorLoggedIn();
  const displayName = loggedIn && visitor && visitor.openidMask
    ? `来访 ${visitor.openidMask}`
    : '访客';

  const handleLogout = (e) => {
    e.preventDefault();
    clearVisitorSession();
    navigate('/login');
  };

  const userMenuItems = [
    { label: '退出（重新登记）', onClick: handleLogout, href: '#' },
  ];

  const makeCityMenu = (citySlug) => {
    const baseMenu = [
      { label: '手工上传数据', href: `/city/${citySlug}/manual-upload` },
      { label: '视频监控', href: `/city/${citySlug}/video` },
    ];

    if (citySlug === 'jinghong') {
      baseMenu.unshift({ label: '工艺流程', href: `/city/${citySlug}/process-diagram` });
    } else {
      baseMenu.unshift({ label: '工艺流程', href: `/city/${citySlug}/process-flow` });
    }

    return baseMenu;
  };

  return (
    <header className="navbar-sticky">
      <div className="navbar-top">
        <div className="navbar-top-inner">
          <span>湖南迪亚环境工程股份有限公司</span>
          <span className="navbar-top-phone">
            咨询热线：
            <a href="tel:073185829688">0731-85829688</a>
          </span>
        </div>
      </div>
      <div className="navbar">
        <div className="nav-inner">
          <div className="nav-left">
            <a className="brand" href="/home">
              <img src="/images/logo.png" alt="企业标志" className="brand-logo" />
              <span className="brand-title">
                湖南迪亚环境工程股份有限公司运营指挥中心
                <span className="brand-sub">数智运营 · 监控审核</span>
              </span>
            </a>
          </div>

          <nav className="nav-menu" aria-label="主导航">
            <Dropdown label="邻水" items={makeCityMenu('linshui')} />
            <Dropdown label="景洪" items={makeCityMenu('jinghong')} />
            <Dropdown
              label="营山"
              items={[
                { label: '实时监控', href: '/yingshan-board' },
                { label: '公司门户', href: '/yingshan-portal' },
              ]}
            />
            <Dropdown label="更多" items={[{ label: '敬请期待', href: '#' }]} />
          </nav>

          {REQUIRE_VISITOR_LOGIN && (
            <div className="nav-right">
              <Dropdown label={displayName} align="right" items={userMenuItems} />
            </div>
          )}
        </div>
      </div>
    </header>
  );
};

export default Navbar;
